import { Dictionary } from '@ngrx/entity';
import { createFeatureSelector, createSelector, DefaultProjectorFn, MemoizedSelector } from '@ngrx/store';

import { recordsAdapter } from '@reducers/records/records.reducer';

import { ApiFragment, FragmentId } from '@stylehaven/components';
import { ApplicationState, RecordsState } from 'state';

export const getRecordsState: MemoizedSelector<
    object,
    RecordsState,
    DefaultProjectorFn<RecordsState>
> = createFeatureSelector<RecordsState>('records');

export const { selectAll, selectEntities } = recordsAdapter.getSelectors(getRecordsState);

export const selectFeature = (state: ApplicationState) => state.records;
export function getRecords(
    ids: FragmentId[]
): MemoizedSelector<object, (ApiFragment | undefined)[], DefaultProjectorFn<(ApiFragment | undefined)[]>> {
    return createSelector(selectEntities, (entries: Dictionary<ApiFragment>) =>
        ids
            .map(id => entries[id])
            .map(entry => {
                if (entry) {
                    return new ApiFragment(entry.metadata);
                }
                return undefined;
            })
    );
}

export function getRecord(
    id: FragmentId
): MemoizedSelector<object, ApiFragment | undefined, DefaultProjectorFn<ApiFragment | undefined>> {
    return createSelector(selectEntities, (entries: Dictionary<ApiFragment>) => {
        const entry: ApiFragment | undefined = entries[id];
        if (entry) {
            return new ApiFragment(entry.metadata);
        }
        return undefined;
    });
}

export function recordsLoadingSelector(state: ApplicationState): boolean {
    return selectFeature(state).loading;
}

export function recordsErrorSelector(state: ApplicationState): boolean {
    return selectFeature(state).error;
}
